import React, { useEffect, useState, useContext } from "react";
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    TextField
} from "@mui/material";
import './style.css'
import LoadingButton from "@mui/lab/LoadingButton";
import blogFetch from "../../../axios/config";
import { Col, Container, Row } from "react-bootstrap";
import Context from "../../../context/Context";
import Box from '@mui/material/Box';

export default function CardConfig({
    data,
    handleEditConfig
}) {

    const {
        itemsPriority,
        setItemsPriority,
        setInputValue,
        inputValue
    } = useContext(Context);

    const [allRestricoes, setAllRestricoes] = useState([]);
    const [restricaoTipo, setRestricaoTipo] = useState('ORDEM');

    useEffect(() => {
        getAllRestricoes();
    }, []);

    const restricao_Tipo = [
        "ORDEM",
        "ZFER",
        "PEDIDO"
    ]

    const filteredRestricoes = allRestricoes.filter(restricoes =>
        restricoes.restricao_Tipo.includes(restricaoTipo)
    );

    const formatString = (string) => string?.replace(/_/g, '').replace(/([A-Z])/g, ' $1')

    const borderColor = (key) => {
        const color = {
            CorHP_CorPreta: 'black',
            CorHP_Vermelhas: 'red'
        }

        return color[key];
    }
    

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleChange = (event) => {
        setRestricaoTipo(event.target.value);
    };

    const handleAddClick = (restricaoTipo) => {
        const numbers = inputValue.split(' ');

        const getRestricaoTipo = (tipo) => {
            switch (tipo) {
                case "ORDEM":
                    return 'ORDEM';
                case "ZFER":
                    return 'ZFER';
                case "PEDIDO":
                    return 'PEDIDO';
                default:
                    return 'DEFAULT_TIPO';
            }
        };

        const newItems = numbers.map(number => ({
            Restricao_Tipo: getRestricaoTipo(restricaoTipo),
            Restricao_Valor: number
        }));

        setItemsPriority([...itemsPriority, ...newItems]);
        setInputValue('');
    };

    const handleRemoveItem = (index) => {
        const newItems = itemsPriority.filter((item, i) => i !== index);
        setItemsPriority(newItems);
    };

    const getAllRestricoes = async () => {
        try {
            const { data } = await blogFetch.get(`/ISAGA_GestaoPCP_Resticoes`);
            setAllRestricoes(data)
        } catch (error) {
            console.error(error);
        }
    }

    const deleteRestricoesById = async (Restricao_Key) => {
        try {
            await blogFetch.delete(`/ISAGA_GestaoPCP_Resticoes/${Restricao_Key}`);
            getAllRestricoes()
        } catch (error) {
            console.error(error);
        }
    };

    const typeComponent = (item) => {
        switch (item.regra_TipoCampo) {
            case 'string':
                return (
                    <InputLabel className="d-flex flex-column me-1 card-inputlaber">
                        {item.regra_Descricao}
                        <TextField
                            className="mb-3"
                            name={item.regra_Nome}
                            id="outlined-basic"
                            variant="outlined"
                            fullWidth
                            value={item.regra_Valor}
                            onChange={(e) => handleEditConfig(e, item.regra_TipoCampo, item.regra_Tipo)}
                        />
                    </InputLabel>
                )
            case 'integer':
                return (
                    <InputLabel className="d-flex flex-column me-1">
                        {item.regra_Descricao}
                        <TextField
                            className="mb-3"
                            name={item.regra_Nome}
                            id="outlined-basic"
                            variant="outlined"
                            fullWidth
                            value={item.regra_Valor}
                            onChange={(e) => handleEditConfig(e, item.regra_TipoCampo, item.regra_Tipo)}
                        />
                    </InputLabel>
                )
            case 'multiselect':
                const ITEM_HEIGHT = 48;
                const ITEM_PADDING_TOP = 8;
                const MenuProps = {
                    PaperProps: {
                        style: {
                            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                            width: 250,
                        },
                    },
                };
                const names = item.regra_Valor.split(';');
                return (
                    <InputLabel className="d-flex flex-column me-1">
                        {item.regra_Descricao}
                        <FormControl sx={{ mb: 1, width: 300 }}>
                            <Select
                                name={item.regra_Nome}
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                value={names}
                                onChange={(e) => handleEditConfig(e, item.regra_TipoCampo, item.regra_Tipo)}
                                input={<OutlinedInput label="Tag" />}
                                renderValue={(selected) => selected.join(', ').replace(/^, /, '')}
                                MenuProps={MenuProps}
                            >
                                {item.regra_TipoValores.split(';').map((name) => (
                                    <MenuItem key={name} value={name}>
                                        <Checkbox checked={names.indexOf(name) > -1} />
                                        <ListItemText primary={name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </InputLabel>
                )
            case 'checkbox':
                return (
                    <InputLabel className="d-flex flex-column me-1">
                        {item.regra_Descricao}
                        <FormControlLabel
                            className="card-checkbox"
                            control={
                                <Checkbox
                                    name={item.regra_Nome}
                                    checked={item.regra_Valor === "1" ? true : false}
                                    onChange={(e) => handleEditConfig({
                                        target: {
                                            name: item.regra_Nome,
                                            value: e.target.checked
                                        }
                                    }, item.regra_TipoCampo, item.regra_Tipo)}
                                />}
                            label={`${formatString(item.regra_Nome)}`}
                        />
                    </InputLabel>
                )
            default:
                return (
                    <span>TIPO DE COMPONENTE NÃO CADASTRADO</span>
                )
            case 'InsertRegra':
                return (
                    <>
                        <div className="d-flex align-items-center">
                            <InputLabel className="d-flex flex-column me-1 w-75">
                                {item.regra_Descricao}
                                <TextField
                                    className="mb-3"
                                    name="regra_nome"
                                    id="outlined-basic"
                                    variant="outlined"
                                    fullWidth
                                    value={inputValue}
                                    onChange={handleInputChange}
                                />
                            </InputLabel>

                            <Box sx={{ minWidth: 120 }}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Restrição Tipo</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={restricaoTipo}
                                        label="Restrição Tipo"
                                        onChange={handleChange}
                                    >
                                        {restricao_Tipo.map((tipo, index) => (
                                            <MenuItem
                                                value={tipo}
                                                key={index}
                                            >
                                                {tipo}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <LoadingButton
                                className="h-75 ms-2"
                                variant="contained"
                                onClick={() => handleAddClick(restricaoTipo)}
                            >
                                Adicionar
                            </LoadingButton>

                        </div>
                        <Container fluid>
                            <Row>
                                <Col className="ps-0">
                                    <div className="tableFixHead tableFixHeadOverflow filawrap border" style={{ minHeight: '400px', maxHeight: '400px' }}>
                                        <InputLabel className="text-center">
                                            Ordens á priorizar
                                        </InputLabel>
                                        <table className="table text-center mt-2 ">
                                            <thead>
                                                <tr>
                                                    <th>VALOR</th>
                                                    <th>REMOVER</th>
                                                </tr>
                                            </thead>
                                            {itemsPriority.length > 0 && (
                                                <tbody>
                                                    {itemsPriority.map((itemPriority, index) => (
                                                        <tr>
                                                            <td className="p-0">{itemPriority.Restricao_Valor}</td>
                                                            <td className="p-0">
                                                                <LoadingButton className="p-0"
                                                                    onClick={() => handleRemoveItem(index)}
                                                                >
                                                                    x
                                                                </LoadingButton>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            )}
                                        </table>
                                    </div>
                                </Col>
                                <Col className="pe-0">
                                    <div>
                                        <div className="tableFixHead tableFixHeadOverflow filawrap border" style={{ minHeight: '400px', maxHeight: '400px' }}>
                                            <InputLabel className="text-center">
                                                Ordens priorizadas
                                            </InputLabel>
                                            <table className="table text-center mt-2 border">
                                                <thead>
                                                    <tr>
                                                        <th>VALOR</th>
                                                        <th>TIPO</th>
                                                        <th>REMOVER</th>
                                                    </tr>
                                                </thead>
                                                {allRestricoes.length > 0 && (
                                                    <tbody>
                                                        {filteredRestricoes.map((restricoes, index) => (
                                                            <tr>
                                                                <td className="p-0">{restricoes.restricao_Valor}</td>
                                                                <td className="p-0">{restricoes.restricao_Tipo}</td>
                                                                <td className="p-0">
                                                                    <LoadingButton
                                                                        onClick={() => deleteRestricoesById(restricoes.restricao_Key)}
                                                                    >
                                                                        x
                                                                    </LoadingButton>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </>
                )
        }
    }

    return (
        <div className="">
            <span className="mt-4 align-items-center h6 fw-bold">{`${formatString(data[0]?.regra_Tipo)}`}</span>
            <div
                className={`p-3 card-piece-sector-${borderColor(data[0]?.regra_Tipo)}`}
                style={{ minHeight: '100vh', maxHeight: '100vh', overflowY: 'auto' }}
            >
                {data.map((item, index) => (
                    <div
                        key={`gestaoPCPRegras-${item.regra_Tipo}-${index}`}
                        className="me-2"
                    >
                        {typeComponent(item)}
                    </div>
                ))}
            </div>
        </div>
    );
}
